export default __webpack_public_path__ + "static/media/landing-image.45b77a48.png";